import { Link } from '@remix-run/react'
import { useState } from 'react'
import { Button } from './ui/button'

const sections = [
	{ label: 'Domů', to: '/' },
	{ label: 'Proč aplikaci?', to: '#benefits' },
	// { label: 'Případové studie', to: '/' },
	// { label: 'Recenze', to: '/' },
	{ label: 'Ceník', to: '#pricing' },
	{ label: 'O nás', to: '#aboutus' },
]

const Menu = () => {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<>
			<Button
				onClick={() => setIsOpen(!isOpen)}
				className="block bg-transparent md:hidden"
			>
				<img src="img/icons/hamburger-menu.svg" alt="menu" />
			</Button>
			{isOpen && (
				<div className="absolute inset-0 h-screen bg-primary text-white">
					<div className="mx-4 mb-10 mt-8 flex justify-between">
						<img
							src="img/icons/notify-logo-mobile-white.svg"
							alt="logo"
							width={158}
							height={30}
						/>
						<Button onClick={() => setIsOpen(!isOpen)}>
							<img src="img/icons/close-menu.svg" alt="close" />
						</Button>
					</div>
					<div className="flex flex-col justify-center gap-4 px-4">
						{sections.map(sections => (
							<div key={sections.label}>
								<Link
									to={sections.to}
									className="font-bold"
									onClick={() => setIsOpen(!isOpen)}
								>
									<div className="mb-2 flex justify-between">
										{sections.label}
										<img src="img/icons/menu-arrow.svg" alt="arrow" />
									</div>
								</Link>
								<img
									src="img/icons/menu-line.svg"
									alt="line"
									className="w-full"
								/>
							</div>
						))}
					</div>
					<div className="flex justify-center">
						<Link
							to="#contact"
							className="absolute bottom-28 w-[90%] rounded-[90px] bg-secondary bg-white px-10 py-4 text-center font-bold text-black"
							onClick={() => setIsOpen(!isOpen)}
						>
							Chci vlastní aplikaci
						</Link>
					</div>
				</div>
			)}
		</>
	)
}

export default Menu
